<template>
	<div class="page">
		<div class="mainArea">
			<router-link to="/pc/see">橙猩视点 > 详情</router-link>
			<div class="contentinfo">				
				<iframe :src="'https://mp.weixin.qq.com/s/'+id" frameborder="0" width="100%" height="500px"></iframe>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'Seeout',
		data() {
			return {
				id:0
			}
		},
		created() {
			let isM=/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
			if(isM){
				this.$router.push({ path: '/mobile/seeInfo?type='+this.$route.query.type});
			}
		},
		mounted() {
			console.log(this.$route.query.id)
			this.id=this.$route.query.id||0			
		},
		methods: {
		}	

	}
</script>
<style lang="less" scoped>
	.page{
		text-align: left;
	}
	.contentinfo{
		position: relative;
		border-radius: 5px;
		padding:40px;
		background: #fff;
		color: #999;
		margin-top: 20px;
		.top{
			border-bottom: 1px solid #ddd;
			h1{
				color: #000;
				font-size: 30px;
			}
			p{text-align: right;color: #999;padding-bottom: 10px;padding-top: 10px;}
		}
		.center{
			h3{
				color: #000;
				font-size: 24px;
				margin-top: 20px;
			}
			p{
				padding-top:10px;
				padding-bottom:10px;
				line-height: 30px;
				color: #555;
				font-size: 16px;
				b{
					color: #000;
					font-weight: 800;
				}
			}
		}
		img{
			width: 100%;
			margin-top: 10px;
			margin-bottom: 10px;
		}
	}
	
	@media (max-width:800px) {
			.contentinfo{
				padding:20px;
				.top{
					h1{
						font-size: 22px;
					}
				}
				.center{
					h3{
						font-size: 20px;
					}
					p{
						font-size: 14px;
					}
				}				
			}
	}
</style>